<template>
  <AppPage class="HelpPage">
    <AppHeader title="AYUDA"
      :left-action="goBack"
      :right-action="goPedido"
     />
    <i class="fa fa-question-circle help-icon"></i>
    <AppSection>
      <p class="text-muted">PARA CUALQUIER DUDA O CONSULTA SOBRE EL PROCESO DE PEDIDO O NUESTROS SERVICIOS, PUEDES PONERTE EN CONTACTO CON NOSTROS EN EL TELÉFONO</p>
      <div class="alert alert-info">
        IMMBOX SOFTWARE S.L. <br>
        CIF. B-55301123 <br>
        DIRECCIÓN, 105 <br>  
        08006 Ibiza
      </div>
      <a href="tel:0034971390284" class="btn btn-lg btn-block btn-action">+34 971 39 02 84</a>
      <p class="text-muted">O EN LA SIGUIENTE DIRECCIÓN DE EMAIL</p>
      <a href="mailto:info@immsoluciones.com" class="btn btn-lg btn-block btn-action">info@immsoluciones.com</a>
      <p class="text-muted">
        <strong>NUESTRO HORARIO</strong>
        <ul class="horario">
          <li>Lunes - Viernes: de 08:00 a 16:00 horas</li>
          <li>Sábados: de 08:00 a 14:00 horas</li>
        </ul>
      </p>
      <button class="btn btn-lg btn-block btn-action" @click="onShowConditionsPopup"> Política de ventas y devoluciones</button>
    </AppSection>
  </AppPage>
</template>
<script>
export default {
  methods: {
    onShowConditionsPopup() {
      this.$store.commit('showConditions', true)
    },
    goBack() {
      this.$router.go(-1)
    },
    goPedido() {
      this.$router.push('/order')
    }
  }
}
</script>

<style lang="scss">
.HelpPage {
  text-align: center;

  .help-icon {
    color: #0a8dce;
    font-size: 5.2rem;
    margin-top: 1rem;
  }

  p {
    font-size: 0.89rem;
    margin: 1.4rem 0;
  }

  .btn-action {
    background-color: #ccc;
    color: #343434;
    padding: 1rem;
  }

  .horario {
    padding: 0.42rem 0 0 0;
    margin: 0;
    list-style: none;

    li {
      padding-top: 0.89rem 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/Help.vue